import { CONTAINER_WIDTH } from '../constants';

export const isDesktop = () => window.innerWidth > 500;

export const getContainerWidth = () => window.innerWidth > CONTAINER_WIDTH ? CONTAINER_WIDTH : window.innerWidth;
